import store from "../../../../store";

/* CLASSES */
const DEFAULT = "";
const HIDE = "hide";
const SIDE = "side";
const FULL_HEIGHT = "full-height";
const VIDEO = "video";
const NO_REMOTE = "no-remote-video";
const SPLIT = "split";
const SPLIT_BOTTOM = "split-bottom";
// const SPLIT_BOTTOM_REMOTE = "remote-split-bottom";
const SPLIT_REMOTE = "remote-split";
const MIRRORED = "mirrored";
const UNMIRRORED = "unmirrored";
const LEFT = "left";
const MINIMIZED = "minimized-side";
const ENLARGED = "enlarged-side";
const COLUMN = "column-side";
const NO_REMOTE_CENTERED = "no-remote-centered";
const NO_LOCAL_VIDEO = "no-local-video";
const HEIGHT_UNSET = "height-unset";
// const SMALL_MARGINED_VIDEO = "small-margined-video";
const TOP_LEFT_SMALL_VIDEO = "top-left-small-video";

// const BOTTOM_LEFT_SLOT_1 = "bottom-left-slot-1";
// const BOTTOM_LEFT_SLOT_2 = "bottom-left-slot-2";
// const BOTTOM_LEFT_SLOT_3 = "bottom-left-slot-3";

const LOCAL_BOTTOM_LEFT_SLOT_1 = "local-bottom-left-slot-1";
const LOCAL_BOTTOM_LEFT_SLOT_2 = "local-bottom-left-slot-2";

// const REMOTE_BOTTOM_LEFT_SLOT_1 = "remote-bottom-left-slot-1";
const REMOTE_BOTTOM_LEFT_SLOT_2 = "remote-bottom-left-slot-2";
const REMOTE_BOTTOM_LEFT_SLOT_3 = "remote-bottom-left-slot-3";

const REMOTE_BOTTOM_LEFT_SIDE_DOUBLE = "remote-bottom-left-side-double";

const CENTER_VIEW = "center-view";

const REMOTE_BOTTOM_LEFT = "remote-bottom-left";
const REMOTE_TOP_SPACE = "remote-top-space";

/* BASE CLASSES ASSIGNED TO RESPECTIVE ELEMENTS IN ALL CASES */
const BASE_CLASSES = {
  localSide: SIDE,
  localVideo: VIDEO,
  localScreenshare: VIDEO,
  remoteSide: SIDE,
  remoteVideo: VIDEO,
  remoteScreenshare: VIDEO,
  localVideoOff: NO_LOCAL_VIDEO,
  noRemoteVideo: NO_REMOTE,
};

const CONFIGS = {
  1: "view1", // Wide layout with remote user at center view
  2: "view2", // Split layout of remote and local
  3: "view3", // Wide layout with local user at center view
};

/* ========== SLOT SYSTEM ========== */
/**
 * Assign slots
 *
 * CENTER_VIEW — Wide layout view in the center
 *
 * Because local and remote elements differ in setup and are separated by sides
 *
 * LOCAL_BOTTOM_LEFT_SLOT_1
 * LOCAL_BOTTOM_LEFT_SLOT_2
 * LOCAL_BOTTOM_LEFT_SLOT_3
 *
 * REMOTE_BOTTOM_LEFT_SLOT_1
 * REMOTE_BOTTOM_LEFT_SLOT_2
 * REMOTE_BOTTOM_LEFT_SLOT_3
 */

const layouts = {
  view1: {
    localSide: {
      default: MINIMIZED + " " + LEFT,
      localScreensharing: MINIMIZED + " " + LEFT + " " + HEIGHT_UNSET + " " + COLUMN,
      remoteScreensharing: MINIMIZED + " " + LEFT,
      bothScreensharing: MINIMIZED + " " + LEFT + " " + HEIGHT_UNSET + " " + COLUMN,
    },
    localVideo: {
      default: DEFAULT /*  */,
      localScreensharing: DEFAULT /* old: BOTTOM_LEFT_SMALL_VIDEO,*/,
      remoteScreensharing: DEFAULT,
      bothScreensharing: DEFAULT /* BOTTOM_LEFT_SMALL_VIDEO,*/,
    },
    localScreenshare: {
      default: HIDE,
      localScreensharing: LOCAL_BOTTOM_LEFT_SLOT_2,
      remoteScreensharing: HIDE,
      bothScreensharing: LOCAL_BOTTOM_LEFT_SLOT_2,
    },
    remoteSide: {
      default: ENLARGED,
      localScreensharing: ENLARGED,
      remoteScreensharing: ENLARGED + " " + COLUMN,
      bothScreensharing: ENLARGED,
    },
    remoteVideo: {
      default: DEFAULT,
      localScreensharing: DEFAULT,
      remoteScreensharing: REMOTE_BOTTOM_LEFT_SLOT_2 /*MINIMIZED + " " + LEFT + " " + TOP_LEFT_SMALL_VIDEO,*/,
      bothScreensharing: REMOTE_BOTTOM_LEFT_SLOT_3 /*MINIMIZED + " " + LEFT + " " + TOP_LEFT_SMALL_VIDEO,*/,
    },
    remoteScreenshare: {
      default: HIDE,
      localScreensharing: HIDE,
      remoteScreensharing: CENTER_VIEW /* FULL_HEIGHT, */,
      bothScreensharing: CENTER_VIEW,
    },
    localVideoOff: {
      default: DEFAULT,
      localScreensharing: DEFAULT,
      remoteScreensharing: DEFAULT,
      bothScreensharing: DEFAULT,
    },
    noRemoteVideo: {
      default: DEFAULT,
      localScreensharing: DEFAULT,
      remoteScreensharing: LEFT,
      bothScreensharing: LEFT,
    },
  },
  view2: {
    localSide: {
      default: DEFAULT,
      localScreensharing: COLUMN,
      remoteScreensharing: COLUMN,
      bothScreensharing: COLUMN,
    },
    localVideo: {
      default: DEFAULT,
      localScreensharing: SPLIT_BOTTOM,
      remoteScreensharing: DEFAULT,
      bothScreensharing: SPLIT_BOTTOM,
    },
    localScreenshare: {
      default: HIDE,
      localScreensharing: SPLIT,
      remoteScreensharing: HIDE,
      bothScreensharing: SPLIT,
    },
    remoteSide: {
      default: DEFAULT,
      localScreensharing: COLUMN,
      remoteScreensharing: COLUMN,
      bothScreensharing: COLUMN,
    },
    remoteVideo: {
      default: DEFAULT,
      localScreensharing: DEFAULT,
      remoteScreensharing: SPLIT_REMOTE,
      bothScreensharing: SPLIT_REMOTE,
    },
    remoteScreenshare: {
      default: HIDE,
      localScreensharing: HIDE,
      remoteScreensharing: SPLIT_BOTTOM,
      bothScreensharing: SPLIT_BOTTOM,
    },
    localVideoOff: {
      default: DEFAULT,
      localScreensharing: DEFAULT,
      remoteScreensharing: DEFAULT,
      bothScreensharing: DEFAULT,
    },
    noRemoteVideo: {
      default: DEFAULT,
      localScreensharing: DEFAULT,
      remoteScreensharing: FULL_HEIGHT,
      bothScreensharing: DEFAULT,
    },
  },
  view3: {
    localSide: {
      default: ENLARGED /*MINIMIZED + " " + LEFT, */,
      localScreensharing: ENLARGED + " " + COLUMN,
      remoteScreensharing: ENLARGED,
      bothScreensharing: ENLARGED,
    },
    localVideo: {
      default: DEFAULT,
      localScreensharing: DEFAULT,
      remoteScreensharing: DEFAULT,
      bothScreensharing: DEFAULT,
    },
    localScreenshare: {
      default: HIDE,
      localScreensharing: LOCAL_BOTTOM_LEFT_SLOT_1 /* LEFT + " " + MINIMIZED + " " + BOTTOM_LEFT_SMALL_VIDEO,*/,
      remoteScreensharing: HIDE,
      bothScreensharing: LOCAL_BOTTOM_LEFT_SLOT_1 /*LEFT + " " + MINIMIZED + " " + BOTTOM_LEFT_SMALL_VIDEO,*/,
    },
    remoteSide: {
      default: LEFT + " " + MINIMIZED,
      localScreensharing: LEFT + " " + MINIMIZED + " " + TOP_LEFT_SMALL_VIDEO,
      remoteScreensharing: LEFT + " " + MINIMIZED + " " + TOP_LEFT_SMALL_VIDEO + " " + COLUMN + " " + REMOTE_BOTTOM_LEFT,
      bothScreensharing: REMOTE_BOTTOM_LEFT_SIDE_DOUBLE,
    },
    remoteVideo: {
      default: DEFAULT,
      localScreensharing: DEFAULT,
      remoteScreensharing: DEFAULT,
      bothScreensharing: DEFAULT,
    },
    remoteScreenshare: {
      default: HIDE,
      localScreensharing: HIDE,
      remoteScreensharing: REMOTE_TOP_SPACE,
      bothScreensharing: REMOTE_TOP_SPACE,
    },
    localVideoOff: {
      default: DEFAULT,
      localScreensharing: DEFAULT,
      remoteScreensharing: DEFAULT,
      bothScreensharing: DEFAULT + LEFT,
    },
    noRemoteVideo: {
      default: LEFT + " " + NO_REMOTE_CENTERED,
      localScreensharing: LEFT + " " + NO_REMOTE_CENTERED,
      remoteScreensharing: LEFT + " " + NO_REMOTE_CENTERED,
      bothScreensharing: LEFT + " " + NO_REMOTE_CENTERED,
    },
  },
};

export function getLayoutElementClasses(config, element) {
  const remoteData = store.state.room.remoteParticipantData;
  const remoteScreenData = store.state.room.remoteParticipantScreenData;
  const localScreenData = store.state.room.localParticipantScreenData;
  const isMirrored = store.state.preferences.videoIsMirrored;

  const REMOTE_IS_SHARING_SCREEN = remoteScreenData && !localScreenData;
  const LOCAL_IS_SHARING_SCREEN = !remoteScreenData && localScreenData;
  const BOTH_SHARING_SCREEN = remoteScreenData && localScreenData;

  const baseClass = BASE_CLASSES[element];
  const layout = CONFIGS[config];

  let customClass = layouts[layout][element]["default"];

  if (REMOTE_IS_SHARING_SCREEN) {
    customClass = layouts[layout][element]["remoteScreensharing"];
  }

  if (LOCAL_IS_SHARING_SCREEN) {
    customClass = layouts[layout][element]["localScreensharing"];
  }

  if (BOTH_SHARING_SCREEN) {
    customClass = layouts[layout][element]["bothScreensharing"];
  }

  let classes = customClass ? baseClass + " " + customClass : baseClass;

  if (element == "localVideo" && isMirrored) {
    classes = classes + " " + MIRRORED;
  }

  if (element == "remoteVideo" && !remoteData) {
    classes = classes + " " + HIDE;
  }

  if (element == "localVideoOff" && !isMirrored) {
    classes = classes + " " + UNMIRRORED;
  }

  return classes;
}

/* ========== POSITIONING LOCAL SCREENSHARE CONTAINER ========== */

export function setDefaultLayout() {
  const layout = {
    default: 1,
    split: 2,
    self: 3,
    // full: 4,
  };

  const currentDefault = store.state.room.sessionPreferences.layout || "default";
  const layoutNum = layout[currentDefault];
  store.dispatch("preferences/toggleLayout", layoutNum);
}

export default {
  getLayoutElementClasses,
};
